import gql from 'graphql-tag';
import { query } from 'services/graphql';

export const signInCodesQuery = gql`
  query signInCodes($input: SignInCodesInput) {
    signInCodes(input: $input) {
      nodes {
        id
        code
        usedOn
        email
      }
      meta {
        totalCount
        count
        totalPages
        offset {
          page
          perPage
        }
      }
    }
  }
`;

export default query(signInCodesQuery);
